var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bb-annotating',_vm._g(_vm._b({attrs:{"type":"comparing","intro":"Start creating your Compare & Contrast block by adding at least two "}},'bb-annotating',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }